(() => {
  if (window.BHGift) return;
  const configElement = document.getElementById('bh-gift-config');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  const checkoutPass = new WeakSet();

  const notice = (message) => {
    window.setTimeout(() => {
      const target = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (target) {
        target.textContent = message;
        target.classList.add('bh-gift-notice');
      }
    }, 0);
  };

  const request = async (path, data) => {
    const options = data ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    } : { headers: { Accept: 'application/json' }, cache: 'no-store' };
    const response = await fetch(`${root}${path}`, options);
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(result.description || result.message || 'Cart request failed');
    return result;
  };

  const parseAttributes = (cart) => {
    try { return JSON.parse(cart.attributes?._kaching_cart_attributes || '{}'); } catch { return {}; }
  };

  const promo = (item) => {
    try { return JSON.parse(item.properties?._kaching_cart || '{}').promoHash === config.promoHash; } catch { return false; }
  };

  const managed = (item) => Number(item.variant_id) === config.giftVariantId && (item.properties?._bh_gift === 'true' || promo(item));
  const eligible = (cart) => cart.items.some((item) => Number(item.product_id) === config.pillowProductId && item.quantity > 0);

  const sectionParameters = (original) => {
    const sections = Object.keys(original?.sections || {});
    return sections.length ? { sections, sections_url: window.location.pathname } : {};
  };

  const syncNow = async (original) => {
    let cart;
    let sections = original?.sections;
    let giftWasAdded = false;
    let changed = false;
    const sectionData = sectionParameters(original);
    const update = async (data) => {
      const result = await request('cart/update.js', { ...data, ...sectionData });
      if (result.sections) sections = result.sections;
      changed = true;
      return result;
    };
    try {
      cart = await request('cart.js');
      const owned = cart.items.filter(managed);
      if (!eligible(cart)) {
        if (owned.length) {
          cart = await update({ updates: Object.fromEntries(owned.map((item) => [item.key, 0])) });
        }
        return original ? { ...original, ...cart, sections: sections || original.sections } : cart;
      }
      if (!config.enabled || !config.available) {
        const paid = owned.filter((item) => item.final_line_price > 0);
        if (paid.length) cart = await update({ updates: Object.fromEntries(paid.map((item) => [item.key, 0])) });
        return original ? { ...original, ...cart, sections: sections || original.sections } : cart;
      }
      const previous = parseAttributes(cart);
      const qualifyingTotal = Math.max(0, cart.total_price - cart.items.filter(promo).reduce((sum, item) => sum + item.final_line_price, 0));
      const attributes = {
        ...previous,
        cartConfigId: config.cartConfigId,
        totalAfterDiscounts: qualifyingTotal,
        subtotalAtPublish: cart.items_subtotal_price,
        originalSubtotalAtPublish: cart.original_total_price,
        marketId: Number(config.marketId),
        marketCurrencyCode: cart.currency
      };
      if (JSON.stringify(previous) !== JSON.stringify(attributes)) {
        cart = await update({ attributes: { _kaching_cart_attributes: JSON.stringify(attributes) } });
      }
      const existingGift = cart.items.find((item) => Number(item.variant_id) === config.giftVariantId && promo(item));
      if (!existingGift) {
        const random = new Uint8Array(6);
        window.crypto.getRandomValues(random);
        const token = Array.from(random, (number) => (number % 36).toString(36)).join('');
        const result = await request('cart/add.js', {
          items: [{
            id: config.giftVariantId,
            quantity: 1,
            properties: {
              _bh_gift: 'true',
              _kaching_cart: JSON.stringify({ promoHash: config.promoHash, promoRewardUniqueId: token })
            }
          }],
          ...sectionData
        });
        if (result.sections) sections = result.sections;
        giftWasAdded = true;
        changed = true;
        cart = await request('cart.js');
      }
      const paidManaged = cart.items.filter((item) => managed(item) && item.final_line_price > 0);
      if (paidManaged.length) {
        cart = await update({ updates: Object.fromEntries(paidManaged.map((item) => [item.key, 0])) });
        notice(config.error);
      }
      const duplicates = cart.items.filter(managed);
      if (duplicates.length > 1 || duplicates.some((item) => item.quantity > 1)) {
        cart = await update({ updates: Object.fromEntries(duplicates.map((item, index) => [item.key, index === 0 ? 1 : 0])) });
      }
      return original ? { ...original, ...cart, sections: sections || original.sections } : cart;
    } catch {
      if (giftWasAdded || cart?.items.some(managed)) {
        try {
          const current = await request('cart.js');
          const paid = current.items.filter((item) => managed(item) && item.final_line_price > 0);
          if (paid.length) cart = await update({ updates: Object.fromEntries(paid.map((item) => [item.key, 0])) });
          else cart = current;
        } catch {
          notice(config.checkError);
          return { ...(original || cart || {}), _bhGiftUnsafe: true };
        }
      }
      notice(config.error);
      if (original && changed && cart) return { ...original, ...cart, sections: sections || original.sections };
      return original || cart;
    }
  };

  window.BHGift = {
    sync(original) {
      const result = queue.then(() => syncNow(original));
      queue = result.catch(() => undefined);
      return result;
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (!(form instanceof HTMLFormElement) || button?.name !== 'checkout') return;
    if (checkoutPass.has(form)) { checkoutPass.delete(form); return; }
    event.preventDefault();
    if (button.dataset.bhChecking === 'true') return;
    button.dataset.bhChecking = 'true';
    button.setAttribute('aria-busy', 'true');
    try {
      const result = await window.BHGift.sync(null);
      if (result?._bhGiftUnsafe) return;
      checkoutPass.add(form);
      form.requestSubmit(button);
    } finally {
      delete button.dataset.bhChecking;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
